import { render, staticRenderFns } from "./PersonProfileHistoryRecordDetails.vue?vue&type=template&id=7f4f0150&scoped=true&"
import script from "./PersonProfileHistoryRecordDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryRecordDetails.vue?vue&type=style&index=0&id=7f4f0150&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4f0150",
  null
  
)

export default component.exports